import { Action } from 'redux';
// Import States.
import {
	AppState,
	EndorsementState,
	getInitialEndorsementState,
} from '@app/redux/states';
// Import Actions.
import {
	EndorsementAction,
	LoadEndorsementAction,
	LoadEndorsementPossiblePerilsAction,
} from '@app/redux/actions';


/**
 * This handles initializing the state.
 * @param state
 * @param action
 */
let initializeState = (state: AppState, action: EndorsementAction): AppState => {
	let newState: AppState = { ...state };
	// Initialize the state.
	if (!newState.endorsements[action.endorsementId]) {
		newState.endorsements[action.endorsementId] = getInitialEndorsementState();
	}
	else {
		newState.endorsements[action.endorsementId] = { ...newState.endorsements[action.endorsementId] };
	}
	return newState;
}

/**
 * Query the state.
 * @param state
 * @param action
 */
let queryEndorsementState = (state: AppState, action: EndorsementAction): EndorsementState => {
	return state.endorsements[action.endorsementId];
}

// Load Endorsement Reducer.

let LoadEndorsementReducer = (state: AppState, action: Action): AppState => {
	let loadEndorsementAction: LoadEndorsementAction = action as LoadEndorsementAction;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state, loadEndorsementAction);

	// Query the state.
	let endorsementState: EndorsementState = queryEndorsementState(newState, loadEndorsementAction);

	endorsementState.endorsement = loadEndorsementAction.endorsement;
	endorsementState.isEndorsementLoaded = true;

	return newState;
}

// Load Endorsement Possible Perils Reducer.

let LoadEndorsementPossiblePerilsReducer = (state: AppState, action: Action): AppState => {
	let loadEndorsementPossiblePerilsAction: LoadEndorsementPossiblePerilsAction = action as LoadEndorsementPossiblePerilsAction;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state, loadEndorsementPossiblePerilsAction);

	// Query the state.
	let endorsementState: EndorsementState = queryEndorsementState(newState, loadEndorsementPossiblePerilsAction);

	endorsementState.endorsementPossiblePerils = loadEndorsementPossiblePerilsAction.endorsementPossiblePerils;
	endorsementState.areEndorsementPossiblePerilsLoaded = true;

	return newState;
}


// Export reducers.
export {
	LoadEndorsementReducer,
	LoadEndorsementPossiblePerilsReducer,
};

// Export initializers.
export {
	initializeState
}

// Export queries.
export {
	queryEndorsementState
};
